<template>
  <div>
    <!-- Page Header -->
    <b-container fluid class="page-header py-5 mb-5 text-center">
      <b-container class="py-5">
        <h1 class="display-3 text-white mb-3 animated slideInDown">Clients</h1>

        <!-- Breadcrumb -->
        <b-breadcrumb
          class="animated slideInDown justify-content-center"
          :items="breadcrumbItems"
          aria-label="breadcrumb"
        >
          <template #item="{ item }">
            <span :class="['breadcrumb-item', item.active ? 'active text-white' : 'text-white']">
              <router-link v-if="item.to" :to="item.to" class="text-white">{{ item.text }}</router-link>
              <span v-else>{{ item.text }}</span>
            </span>
          </template>
        </b-breadcrumb>
      </b-container>
    </b-container>

    <!-- Clients Section -->
    <b-container class="py-5">
    <div v-for="section in clientSections" :key="section.title" class="mb-5">
      
      <h3 class="text-center fw-bold mb-4 section-title">{{ section.title }}</h3>
      
      <div class="client-grid-wrapper p-4 p-md-5 mb-4">
        <b-row class="g-4 justify-content-center">
          
          <b-col 
            v-for="(client, index) in section.clients" 
            :key="index" 
            cols="6" 
            sm="4" 
            md="3" 
            class="d-flex justify-content-center"
          >
            <div class="logo-box shadow-sm">
              <img :src="client.logo" :alt="client.name" class="client-logo" />
            </div>
          </b-col>

        </b-row>
      </div>
      
      <hr v-if="section.title !== 'Oil and Gas'" class="section-divider" />
    </div>
  </b-container>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const clientSections = ref([
  {
    title: 'Corporate Organizations',
    clients: [
      { name: 'Auto Meridian', logo: require('../assets/client-1.png') },
      { name: 'John Holt', logo: require('../assets/client-7.png') },
      { name: 'Equipment Hall', logo: require('../assets/client-4.png') },
      { name: 'International Breweries', logo: require('../assets/client-6.png') }
    ]
  },
  {
    title: 'Educational Institutions',
    clients: [
      { name: 'Kings University', logo: require('../assets/client-20.png') },
      { name: 'Lead City University', logo: require('../assets/client-21.png') },
      { name: 'Osun State University', logo: require('../assets/client-22.png') },
      { name: 'University of Nigeria', logo: require('../assets/client-23.png') }
    ]
  },
  {
    title: 'Financial Institutions',
    clients: [
      { name: 'Accion Microfinance', logo: require('../assets/client-2.png') },
      { name: 'The chartered', logo: require('../assets/client-24.png') }
    ]
  },
  {
    title: 'Government',
    clients: [
      { name: 'LACVIS', logo: require('../assets/client-9.png') },
      { name: 'LASRAB', logo: require('../assets/client-10.png') },
      { name: 'LASRRA', logo: require('../assets/client-11.png') },
      { name: 'OAU HC', logo: require('../assets/client-12.png') }
    ]
  },
  {
    title: 'NGOs',
    clients: [
      { name: 'Kingsway', logo: require('../assets/client-13.png') },
      { name: 'Methodist church', logo: require('../assets/client-14.png') },
      { name: 'The Redeemed church', logo: require('../assets/client-15.png') },
      { name: 'University of Nigeria', logo: require('../assets/client-16.png') }
    ]
  },
  {
    title: 'Oil and Gas',
    clients: [
      { name: 'Coniol', logo: require('../assets/client-25.png') },
      { name: 'Heyden', logo: require('../assets/client-26.png' )},
      { name: 'NNPC', logo: require('../assets/client-27.png') }
    ]
  },
])

const breadcrumbItems = [
  { text: 'Home', to: '/' },
  { text: 'Clients',to: '/clients' }
]
</script>

<style scoped>
.page-header {
  background: linear-gradient(rgba(22, 22, 22, 0.7), rgba(22, 22, 22, 0.7)),
    url('@/assets/carousel_1.jpg') center center no-repeat;
  background-size: cover;
  font-family: 'Poppins', sans-serif;
}

.breadcrumb-item {
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
}

.breadcrumb {
  background-color: transparent !important;
  padding: 0;
  margin: 0;
}

.breadcrumb-item .router-link-active,
.breadcrumb-item .router-link-exact-active,
.breadcrumb-item a {
  color: white !important;
  text-decoration: none;
}

h1 {
  font-size: 3rem;
  font-family: 'Poppins', sans-serif;
  font-weight: bold;
}

/* Clients Section */
.client-grid-container {
  background-color: #e9ecef;
  border-radius: 40px;
}

.logo-card {
  background-color: #ffffff;
  border-radius: 12px;
  width: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease-in-out;
}

.logo-card:hover {
  transform: translateY(-5px);
}

.logo-card img {
  max-height: 80%;
  max-width: 80%;
  object-fit: contain;
}
.section-title {
  color: #333;
  text-transform: capitalize;
  position: relative;
  padding-bottom: 10px;
}

/* The light gray outer container from your reference image */
.client-grid-wrapper {
  background-color: #f2f2f2; 
  border-radius: 30px;
}

/* The white box for each logo */
.logo-box {
  background-color: #ffffff;
  border-radius: 15px;
  width: 100%;
  aspect-ratio: 1 / 1; /* Keeps it square like the picture */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  transition: transform 0.3s ease;
}

.logo-box:hover {
  transform: scale(1.05);
}

.client-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* Prevents logo stretching */
}

.section-divider {
  width: 50px;
  margin: 40px auto;
  border-top: 3px solid #dc3545; /* Red accent matching your video */
  opacity: 1;
}
</style>
